<template lang="pug">
.max-w-screen-xl.mx-auto.p-6
  button(v-for="type in eventTypes" @click="type.selected = !type.selected" :style="'background-color:' + type.color + ';'" :class="type.selected ? '' : 'opacity-50'").text-white.p-4.mx-4.rounded-md {{ type.name }}
  FullCalendar(:options="calendarOptions" ref="calendar").my-4
  a(v-for="type in eventTypes" :href="webcalBase + (type.link || type.name) + webcalSuffix").m-4
    img(src="/ical-feed-icon-34x14.png").inline-flex.mr-1
    span {{ type.name }}
  a(:href="webcalBase + 'all' + webcalSuffix").m-4
    img(src="/ical-feed-icon-34x14.png").inline-flex.mr-1
    span Abonnement à tous les calendriers
</template>
<script setup>
  import FullCalendar from '@fullcalendar/vue3'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import interactionPlugin from '@fullcalendar/interaction'
  import frLocale from '@fullcalendar/core/locales/fr'
  import iCalendarPlugin from '@fullcalendar/icalendar'

  useHead({
    title: 'Agenda'
  })

  const runtimeConfig = useRuntimeConfig()
  const baseURL = runtimeConfig.public.API_BASE_URL.replace('https', '').replace(
    'http',
    ''
  )
  const webcalBase = `webcal${baseURL}/agenda/`
  const webcalSuffix = ref('')

  const calendar = ref()
  const dateNow = parseInt(Date.now() / 1000)

  const eventTypes = ref([
    {
      name: 'Animation',
      color: '#00dce0',
      selected: true,
    },
    {
      name: 'Entretien',
      link: 'Entretien des locaux',
      color: '#ffb747',
      selected: true,
    },
    {
      name: 'Examens',
      color: '#1fa6e0',
      selected: true,
    },
    {
      name: 'Rendez-vous',
      color: '#55d385',
      selected: true,
    },
    {
      name: 'Réunion',
      color: '#ff7e65',
      selected: true,
    },
  ])

  const calendarOptions = ref({
    locale: frLocale,
    plugins: [dayGridPlugin, interactionPlugin, iCalendarPlugin],
    initialView: 'dayGridMonth',
    eventDisplay: 'block',
    eventClick: (info) => {
      info.jsEvent.preventDefault()
      navigateTo(fixDrupalLink(info.event.url) || '/agenda')
    },
  })

  const setEventSources = () => {
    const selectedEventTypes = eventTypes.value
      .filter((type) => type.selected == true)
    selectedEventTypes.push({
      name: 'Calendrier',
      color: '#2C3E50A5',
      })
    calendarOptions.value.eventSources = selectedEventTypes
      .map((type) => {
        return {
          url: `/backend/agenda/${type.link || type.name}/3ifa-feeds-agenda.ics`,
          format: 'ics',
          color: type.color,
        }
      })
  }

  setEventSources()

  watch(
    [eventTypes],
    () => {
      setEventSources()
    },
    { deep: true }
  )

  const user = useState('user')

  onMounted(async () => {
    const { $refreshUser } = useNuxtApp()
    await $refreshUser()
  })

  watch([user], () => {
    if (user.value) {
      const uid = user.value.uid
      const id = user.value.id
      const hashString = btoa(`${uid}_${id}`)
      webcalSuffix.value = `/3ifa-feeds-agenda.ics?token=${hashString}`
    }
  })
</script>
 